import { Types } from "../elements/reactive/types";

export type XRRenderableType = "Image" | "3D" | "Video";

export const XR_RENDERABLE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gltf",
  "glb",
  "obj",
  "mp4",
];
export const XR_RENDERABLE_TESTERS: {
  [key in XRRenderableType]: RegExp;
} = {
  ["Image"]: /\.(png|jpg|jpeg)$/,
  ["3D"]: /\.(gltf|glb)$/,
  ["Video"]: /\.(mp4)$/,
};

const testerArray = Object.entries(XR_RENDERABLE_TESTERS) as [
  XRRenderableType,
  RegExp
][];

export function getRenderableType(
  file?: Types["File"]
): XRRenderableType | undefined {
  if (!file?.path) return undefined;

  for (const [key, regex] of testerArray) {
    if (regex.test(file.path)) return key;
  }

  return undefined;
}
